<template>
  <div class="cat-tipos-cedula">
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" class="form-control" v-model="idDelModelo" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un tipo de cédula</option>
        <option v-else="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todas.Nombre}} los tipos de cédula</option>
        <option v-for="tipoCedula in tiposCedula" :value="tipoCedula.TipoCedulaId">{{tipoCedula.Nombre}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import axios from 'axios';
  import api from '@/../static/js/api';
  import comun from '@/../static/js/comun';

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        tiposCedula: [],
        idDelModelo: null
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object
    },
    mounted() {
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }

      this.$store.dispatch("A_SINOJ_Catalogos_establecer002TiposCedula", parametros);
    },
    methods: {
      cargaCatalogoDeTiposCedulas: function() {
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba;
        this.parametros.conAreasDeJurisdiccion = true;

        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);

        axios.post(api.conexion + api.SINOJ.catalogos.C002TiposCedula, this.parametros, headerPeticion)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.tiposCedula = respuesta.data.TiposCedula;
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },
      cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        this.$store.dispatch("A_SINOJ_Catalogos_establecer002TiposCedula", parametros);
        this.$emit("valorParaElPadre", evento);
      }
    },
    created() {
      this.cargaCatalogoDeTiposCedulas();
    }
  }
</script>
<style>
.cat-tipos-cedula .form-control {
  background-color: white !important;
        color: black !important;
}
</style>



// WEBPACK FOOTER //
// src/components/SINOJ/Comun/Catalogos/C002TiposCedula.vue